import { Divider, Grid, Grow, Paper, Skeleton, Slide, Zoom } from "@mui/material";
import { MaterialList, MaterialWithLink } from "../../components/MaterialList";
import { DefaultSetting } from "../../defaultSetting";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import SchoolIcon from '@mui/icons-material/School';
import Groups2Icon from '@mui/icons-material/Groups2';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TvIcon from '@mui/icons-material/Tv';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import EditIcon from '@mui/icons-material/Edit';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import { setMaterialGroupRender, setMaterialGroupSecondCol } from "../../../system/Slicer/HomePageSlicer";
import { selectComponentStore } from "../../../system/PageStore";
import { Box } from "@mui/system";

export function HomePageMaterials() {
    const navigate = useNavigate();
    const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    const dispatch = useDispatch();
    const componentStates = useSelector(selectComponentStore);

    const scrollHandler = (_: any) => {
        if (inputRef.current.getBoundingClientRect().top <= DefaultSetting.renderDistance) dispatch(setMaterialGroupRender((true)))
    };
    useEffect(() => {
        window.addEventListener("scroll", scrollHandler, true);
        return () => window.removeEventListener("scroll", scrollHandler, true);
    }, []);


    let dataLeft: Array<MaterialWithLink> = [
        {
            name: "學校處理投訴指引",
            src: "http://www.pkps.edu.hk/pdf/2015-2016/%E5%AD%B8%E6%A0%A1%E8%99%95%E7%90%86%E6%8A%95%E8%A8%B4%E6%8C%87%E5%BC%95.pdf",
            icon: <PictureAsPdfIcon sx={{ color: "red" }} />
        },
        {
            name: "媒體報道",
            src: "http://www.pkps.edu.hk/newhtml/medium.html",
            icon: <TvIcon sx={{ color: "#ff5667" }} />
        },
        {
            name: "1275旅幼童軍",
            src: "/scout",
            useNavigate: true,
            icon: <ArchitectureIcon sx={{ color: "#ff6d77" }} />
        },
        {
            name: "培小家長義工",
            src: "/volunteer",
            useNavigate: true,
            icon: <Diversity3Icon sx={{ color: "#ffa070" }} />
        },
        {
            name: "家長教師會",
            src: "http://www.pkps.edu.hk/newhtml/sch6.html",
            icon: <FamilyRestroomIcon sx={{ color: "#ffb834" }} />
        },

    ];

    let dataRight: Array<MaterialWithLink> = [
        {
            name: "成功父母學堂",
            src: "/parentCourse",
            useNavigate: true,
            icon: <Groups2Icon sx={{ color: "#0AF" }} />
        },
        {
            name: "學校發展與問責數據平台",
            src: "https://203.198.166.249/school/",
            icon: <PictureAsPdfIcon sx={{ color: "#0CF" }} />
        },

        {
            name: "統一登入系統",
            src: "https://clo.edb.gov.hk/Home/Index",
            icon: <LaptopChromebookIcon sx={{ color: "#ffb459" }} />
        },
        {
            name: "培小校友會",
            src: "http://www.pkps.edu.hk/alumni/index.html",
            icon: <Diversity3Icon sx={{ color: "#fc6" }} />
        },

    ];

    return (

        <Paper ref={inputRef} elevation={0} sx={{ m: 1, p: 2, borderRadius: DefaultSetting.borderRadius }}>
            {
                !componentStates.HomePageComponentReducer.materListGroup &&
                <Skeleton height={"500px"} />
            }
            {componentStates.HomePageComponentReducer.materListGroup &&
                <>
                    <Divider sx={{ p: 2 }}>其他</Divider>
                    <Grid container direction="row" justifyContent="center" alignItems="top" spacing={1}>
                        <Grid item xs={10} sm={6}>
                            <Slide in direction={"right"} timeout={500} addEndListener={() => { setTimeout(() => dispatch(setMaterialGroupSecondCol(true)), 500) }}>
                                <Box>
                                    <MaterialList data={dataLeft} />
                                </Box>
                            </Slide>
                        </Grid>
                        <Grid item xs={10} sm={6}>
                            <Slide in={componentStates.HomePageComponentReducer.materListSecondColumIn} direction={"left"} timeout={500}>
                                <Box>
                                    <MaterialList data={dataRight} />
                                </Box>
                            </Slide>
                        </Grid>
                    </Grid>
                </>
            }
        </Paper>
    )
}